import React, { FC } from 'react';
import {
  Text,
  Box,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalSize,
  ButtonAppearance,
  Button,
  ModalClose,
} from '@bechtel/gds';
import { ApolloError } from '@apollo/client';
import { t, Trans } from '@lingui/macro';
import { CreateRodRequestErrorProps } from './types';
import { CreateRodRequestErrorCode } from '@bechtel/types';

const getErrorMessage = (error: CreateRodRequestErrorProps['error']) => {
  if (error instanceof ApolloError) {
    return <Trans>Network error has occured.Please close button and try again.</Trans>;
  }
  switch (error) {
    case CreateRodRequestErrorCode.COMMENT_TOO_LARGE:
      return <Trans>Comment is too large.</Trans>;
    case CreateRodRequestErrorCode.WELD_PROCEDURE_NOT_APPLICABLE:
      return <Trans>Weld procedure is not applicable.</Trans>;
    case CreateRodRequestErrorCode.STENCIL_EMPTY:
      return <Trans>Stencil is empty.</Trans>;
    case CreateRodRequestErrorCode.MISSING_REQUIRED_PERMISSION:
      return <Trans>Missing required permission.</Trans>;
    case CreateRodRequestErrorCode.SERVICE_PROXY_ERROR:
      return <Trans>Service proxy error.</Trans>;
    case CreateRodRequestErrorCode.CREATE_ROD_REQUEST_ERRORED:
      return <Trans>Error in creating rod request.</Trans>;
    default:
      return <Trans>An error has occured. Please click close button and try again.</Trans>;
  }
};

export const CreateRodRequestError: FC<CreateRodRequestErrorProps> = ({ error, close }) => {
  return (
    <Modal visible size={ModalSize.DEFAULT} style={{ width: '400px', height: '275px' }}>
      <ModalHeader title={t`Rod Request Error`}>
        <ModalClose onClick={close}></ModalClose>
      </ModalHeader>
      <ModalBody>
        <Box p={{ sm: '500' }}>
          <Text size="500">{getErrorMessage(error)}</Text>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <Button appearance={ButtonAppearance.SECONDARY} onClick={close}>
              <Trans> Close</Trans>
            </Button>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
